import { useEffect } from 'react';
import logon from '../images/logon.webp';

export default function QuienesSomos() {
  useEffect(() => {
    document.title = 'Quiénes somos | Funeraria Coquimbo';

    const description = document.querySelector('meta[name="description"]');
    description?.setAttribute(
      'content',
      'Conozca la historia, el compromiso y los servicios de Funeraria Coquimbo.'
    );

    let canonical = document.querySelector('link[rel="canonical"]');

    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }

    canonical.setAttribute(
      'href',
      'https://funerariacoquimbo.cl/QuienesSomos'
    );
  }, []);

  return (
    <section className="w-full py-12 md:py-24 lg:py-20">
      <div className="container px-4 md:px-6 mx-auto max-w-4xl">
        <div className="flex flex-col items-center space-y-4 p-0 text-center">
          <img
            src={logon}
            alt="Funeraria Coquimbo"
            className="h-24 md:h-24 transition-transform duration-300 ease-in-out hover:scale-105"
          />

          <h1 className="mt-8 text-3xl text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 lg:text-4xl font-semibold">
            Quiénes <span className="text-[#DBAC5B]">somos</span>
          </h1>
        </div>

        <div className="mt-8 space-y-12">
          <div className="space-y-4">
            <h2 className="text-3xl text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 lg:text-4xl font-semibold">
              Nuestra <span className="text-[#DBAC5B]">Historia</span>
            </h2>

            <p className="text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 text-xl">
              Ubicada en el corazón de Coquimbo, nuestra funeraria se dedica a brindar un apoyo integral y compasivo a la comunidad. Acompañamos a las familias en sus momentos más difíciles, ofreciendo un servicio que combina la calidez humana con la profesionalidad.
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-3xl lg:text-4xl text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 font-semibold">
              Nuestro <span className="text-[#DBAC5B]">Compromiso</span>
            </h2>

            <p className="text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 text-xl">
              En Funeraria Coquimbo, entendemos que cada vida es única y merece ser honrada de manera especial. Nos dedicamos a proporcionar servicios funerarios personalizados que reflejen la vida y los deseos de sus seres queridos, siempre con el máximo respeto y dignidad.
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-3xl text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 lg:text-4xl font-semibold">
              Servicios <span className="text-[#DBAC5B]">Integrales</span>
            </h2>

            <p className="text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 text-xl">
              Ofrecemos una gama completa de servicios funerarios, incluyendo:
            </p>

            <ul className="grid grid-cols-2 gap-2 text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 text-xl">
              <li className="flex items-center">
                <span className="mr-2 text-[#DBAC5B]">•</span> Velatorios
              </li>
              <li className="flex items-center">
                <span className="mr-2 text-[#DBAC5B]">•</span> Cremaciones
              </li>
              <li className="flex items-center">
                <span className="mr-2 text-[#DBAC5B]">•</span> Traslados
              </li>
              <li className="flex items-center">
                <span className="mr-2 text-[#DBAC5B]">•</span> Asesoría legal
              </li>
            </ul>
          </div>

          <div className="space-y-4">
            <h2 className="text-3xl text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 lg:text-4xl font-semibold">
              Nuestro <span className="text-[#DBAC5B]">Equipo</span>
            </h2>

            <p className="text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 text-xl">
              Contamos con un equipo de profesionales comprometidos y empáticos, formados para brindar el mejor apoyo en momentos difíciles. Nuestro personal está disponible las 24 horas del día, los 365 días del año, para atender sus necesidades con la sensibilidad y el respeto que merecen.
            </p>
          </div>
        </div>

        <div className="mt-12 text-center py-4">
          <p className="text-[#DBAC5B] italic text-xl">
            "Calidez humana que marca la diferencia"
          </p>
        </div>
      </div>
    </section>
  );
}